import { useState } from "react";
import { Shield, Clock, CheckCircle, Mail } from "lucide-react";
import InsuranceCheckoutDialog from "./InsuranceCheckoutDialog";

const benefits = [
  { icon: Shield, title: "Proteção contra Furto e Roubo", desc: "Cobertura completa em caso de furto ou roubo do seu aparelho." },
  { icon: Clock, title: "Atendimento 24h", desc: "Suporte técnico e atendimento disponível 24 horas por dia." },
  { icon: CheckCircle, title: "Sem Carência", desc: "Proteção imediata, sem período de carência após a contratação." },
];

const plan = { name: "Premium", price: "R$ 49,99/mês", features: ["Furto", "Roubo", "Suporte 24h", "Sem carência"] };

const InsuranceSection = () => {
  const [checkoutOpen, setCheckoutOpen] = useState(false);

  return (
    <section id="seguro" className="relative pb-32 pt-20 bg-secondary">
      <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-b from-transparent via-secondary/50 to-background pointer-events-none" />
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-gradient-gold mb-4">Seguro para Celulares</h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            Proteja seu smartphone com nossos planos completos e acessíveis
          </p>
          <p className="text-sm text-primary font-semibold mt-2">⚠️ Disponível apenas para aparelhos com sistema Android</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-16">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="bg-card border border-border rounded-xl p-6 text-center hover:border-gold hover:-translate-y-1 transition-all duration-300"
            >
              <b.icon className="w-10 h-10 text-primary mx-auto mb-4" />
              <h3 className="font-display text-lg font-semibold text-foreground mb-2">{b.title}</h3>
              <p className="text-sm text-muted-foreground">{b.desc}</p>
            </div>
          ))}
        </div>

        <div className="max-w-md mx-auto">
          <div className="rounded-xl p-8 border border-primary bg-card shadow-gold glow-gold">
            <span className="block text-center text-xs font-bold bg-gradient-gold text-primary-foreground px-3 py-1 rounded-full mb-4 mx-auto w-fit">
              Plano Exclusivo
            </span>
            <h3 className="font-display text-2xl font-bold text-foreground text-center mb-2">{plan.name}</h3>
            <p className="text-3xl font-bold text-gradient-gold text-center mb-6">{plan.price}</p>
            <ul className="space-y-3 mb-6">
              {plan.features.map((f) => (
                <li key={f} className="flex items-center gap-2 text-sm text-foreground">
                  <CheckCircle className="w-4 h-4 text-primary flex-shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
            <button
              onClick={() => setCheckoutOpen(true)}
              className="w-full py-3 rounded-lg font-semibold bg-gradient-gold text-primary-foreground hover:opacity-90 transition-all hover:scale-[1.02] active:scale-[0.98]"
            >
              Contratar
            </button>
            <div className="mt-4 rounded-lg bg-secondary border border-border p-3 flex items-start gap-2">
              <Mail className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
              <p className="text-xs text-muted-foreground">
                Em caso de sinistro, envie o <strong className="text-foreground">Boletim de Ocorrência</strong> ou <strong className="text-foreground">Boletim Unificado</strong> para{" "}
                <a href="mailto:srsoftware.rh@gmail.com" className="text-primary underline hover:opacity-80">srsoftware.rh@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <InsuranceCheckoutDialog open={checkoutOpen} onOpenChange={setCheckoutOpen} />
    </section>
  );
};

export default InsuranceSection;